const sortByField = function (a, b, field) {
  const _a = field.split('.').reduce((o, i) => o[i], a)
  const _b = field.split('.').reduce((o, i) => o[i], b)

  if (_a < _b) return -1
  if (_a > _b) return +1
  return 0

  // if (a[field] < b[field]) return -1
  // if (a[field] > b[field]) return +1
  // return 0
}

const sortBySequence = function (a, b) {
  return sortByField(a, b, 'sequence')
}
const orderBySequence = function (a, b) {
  return sortByField(a, b, 'sequence')
}
const sortByLastname = function (a, b) {
  return sortByField(a, b, 'lastname')
}
const sortByTitleLocale = (locale) => (a, b) => sortByField(a, b, `title.${locale}`)
const sortByTitle = function (a, b) {
  return sortByField(a, b, 'title')
}
const orderByCreatedDate = function (a, b) {
  a = new Date(a.created)
  b = new Date(b.created)
  if (a.getTime() < b.getTime()) return -1
  if (a.getTime() > b.getTime()) return  1
  return 0
}
const humanizeSize = function (bytes) {
  let i = -1
  const units = ['кБ', 'МБ']
  do {
    bytes = bytes / 1024
    i++
  } while ((bytes > 1024) && (i <= 2))

  return Math.max(bytes, 0.1).toFixed(1) + units[i]
}
const printFloat = function (val) {
  if (val === '') {
    return ''
  }

  val = parseFloat(val).toFixed(2)
  return parseFloat(val)
}

export {sortBySequence, orderBySequence, sortByLastname, sortByTitleLocale, sortByTitle, orderByCreatedDate, humanizeSize, printFloat}
